import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
    providedIn: 'root'
})
export class DialogService {
    showError(message: string, title?: string) {
        
        return Swal.fire({
            title: title ?? 'Error',
            html: this.formatMessage(message),
            icon: 'error',
            confirmButtonText: 'OK',
            confirmButtonColor: '#3085d6',
        });
    }

    showSuccess(message: string, title?: string) {
        return Swal.fire({
            title: title ?? 'Success',
            html: this.formatMessage(message),
            icon: 'success',
            confirmButtonText: 'OK',
            confirmButtonColor: '#3085d6',
            timer: 1500,
            timerProgressBar: true
        });
    }

    showWarning(message: string, title?: string) {
        return Swal.fire({
            title: title ?? 'Warning',
            html: this.formatMessage(message),
            icon: 'warning',
            confirmButtonText: 'OK',
            confirmButtonColor: '#3085d6',
        });
    }

    async showWarningConfirmation(title: string, message: string) {
        const result = await Swal.fire({
            title: title,
            html: this.formatMessage(message),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Yes, synchronize',
            cancelButtonText: 'Cancel'
        });

        return result.isConfirmed;
    }

    async showConfirmation(title: string, message: string) {
        const result = await Swal.fire({
            title: title,
            html: this.formatMessage(message),
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        });

        return result.isConfirmed;
    }

    showLoading(message: string = 'Please wait...') {
        Swal.fire({
            title: 'Processing',
            html: `<p>${message}</p>`,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });
    }

    closeLoading() {
        Swal.close();
    }

    private formatMessage(message: string): string {
        return `<p>${message.replace(/\n/g, '<br/>')}</p>`;
    }
}